export default "__VITE_ASSET__BYbOr9Ak__"